export enum VisitorType {
  Guest = 'Guest',
  Trainee = 'Trainee',
}
